<template>
      <v-navigation-drawer
          dark
          absolute
          height="750"
          width="260"
          class="drawer"
          hide-overlay
          temporary
          v-model="show_drawer"
      >
        <v-list>
          <v-list-item class="pb-2 pl-2">
            <div class="d-flex">
              <v-img :src="require('@/assets/balon.svg')" contain max-height="60" max-width="55" class="px-0"></v-img>
                <v-btn x-small dense fab color="grey lighten-4 my-auto ml-3" @click="show_drawer = !show_drawer">
                  <v-icon color="red lighten-1">
                    {{ expanded ? 'mdi-chevron-double-left' : 'mdi-chevron-double-right' }}
                  </v-icon>
                </v-btn>
            </div>
            <v-fade-transition>
              <v-list-item-content class="py-0 ml-3" v-if="expanded">
                <v-list-item-title class="pt-0 mb-0">Picoballoon</v-list-item-title>
              </v-list-item-content>
            </v-fade-transition>
          </v-list-item>

          <v-divider></v-divider>
        </v-list>

        <div v-if="devices.length > 1" class="px-2 pt-2">
          <v-btn-toggle v-model="selected_device_index" mandatory dense class="d-flex flex-wrap">
            <v-btn
                v-for="device in devices"
                :key="device.slug"
                x-small
                class="sidebar-device-btn"
            >
              <span
                  class="device-dot mr-1"
                  :style="{ background: get_device_color(device.slug) }"
              ></span>
              <span class="text-truncate" style="max-width: 70px;">{{ device.name }}</span>
              <v-icon v-if="device.released_after_id === null" x-small color="orange darken-1" class="ml-1">mdi-bug</v-icon>
            </v-btn>
          </v-btn-toggle>
        </div>

        <data-points :expanded="expanded"></data-points>

        <template v-slot:append>
          <div class="pl-2 mb-4 mt-3">
            <v-btn small light rounded @click="$vuetify.goTo('.table-wrapper')">
              history <v-icon small color="red lighten-1">mdi-chevron-double-down</v-icon>
            </v-btn>
          </div>
        </template>

      </v-navigation-drawer>

</template>

<script>
import DataPoints from "@/components/DataPoints";
import {PointsStore} from "@/store";
import {storeToRefs} from 'pinia';

export default {
  name: "AppBar",
  components: {DataPoints},
  props: ["visible"],
  setup() {
    const points_store = PointsStore();
    const {devices, selected_device} = storeToRefs(points_store);
    return {points_store, devices, selected_device};
  },
  data() {
    return {
      expanded: true,
    }
  },
  computed: {
    show_drawer: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('visible', value);
      }
    },
    selected_device_index: {
      get() {
        return this.devices.findIndex(d => d.slug === this.selected_device);
      },
      set(index) {
        if (this.devices[index]) {
          this.points_store.select_device(this.devices[index].slug);
        }
      }
    }
  },
  methods: {
    get_device_color(slug) {
      return this.points_store.get_device_color(slug);
    }
  }
}
</script>

<style scoped lang="scss">
.border-white {
  border: 1px solid white;
  border-radius: 100%;
}
.drawer {
  &:before {
    content: '';
    border-left: 1px dashed white;
    height: 90%;
    width: 1px;
    position: absolute;
    left: 18px;
   }
}
.v-navigation-drawer--mini-variant.v-navigation-drawer--custom-mini-variant .v-list-item {
  justify-content: left;
}
.v-btn--fab.v-size--x-small {
  width: 22px;
  height: 22px;
}
.v-list-item__subtitle {
  font-size: 0.7em !important;
}
.device-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.sidebar-device-btn {
  width: calc(50% - 1px) !important;
  flex: 0 0 calc(50% - 1px) !important;
}
</style>
